import React, { useState } from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import { StoreCard } from "../../../lib/types/detailsTypes";
import FrontPopUp from "./frontPopUp";
import BackPopUp from "./backPopUp";
import SettingsPopUp from "./settingsPopUp";
import { MoreHoriz } from "@mui/icons-material";

// import { useSwipeable } from "react-swipeable";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

interface CardPopupProps {
  cards: StoreCard[];
  startIndex: number;
  open: boolean;
  onClose: () => void;
}

const CardPopup: React.FC<CardPopupProps> = ({
  cards,
  startIndex,
  open,
  onClose,
}) => {
  // Track which panel is shown: front, back, or settings
  const [view, setView] = useState<"front" | "back" | "settings">("front");
  const [idx, setIdx] = useState(startIndex);
  const cardsLen = cards.length;

  // Toggle between front and back views
  const handleToggleSide = () => {
    setView((prev) => (prev === "front" ? "back" : "front"));
  };

  // Enter settings view
  const handleOpenSettings = () => {
    setView("settings");
  };

  // Return from settings to back view
  const handleBackFromSettings = () => {
    setView("back");
  };

  /* helpers to cycle */
  const next = () => setIdx((i) => (i + 1) % cards.length);
  const prev = () => setIdx((i) => (i - 1 + cards.length) % cards.length);

  /* attach swipe handlers */
  // const swipeHandlers = useSwipeable({
  //   onSwipedLeft: next,
  //   onSwipedRight: prev,
  //   trackTouch: true,
  //   trackMouse: false,
  // });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(255, 248, 240, 0.95)",
        },
      }}
      PaperProps={{
        sx: {
          backgroundColor: "transparent",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
          borderRadius: 4,
          overflow: "visible",
        },
      }}
    >
      <DialogContent
        sx={{
          p: 0,
          position: "relative",
          overflow: "visible",
        }}
      >
        {/* Flip icon shown on front and back views */}
        {view !== "settings" && (
          <IconButton
            onClick={handleToggleSide}
            aria-label="Flip Card"
            size="small"
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 10,
              bgcolor: "#fff",
              "&:hover": { bgcolor: "#f0f0f0" },
            }}
          >
            <MoreHoriz />
          </IconButton>
        )}
        {cardsLen > 1 && view !== "settings" && (
          <>
            {/* ← left arrow */}
            <IconButton
              aria-label="Previous card"
              onClick={prev}
              sx={{
                position: "absolute",
                left: -40, // tuck half-way outside the card
                top: "50%",
                transform: "translateY(-50%)",
                bgcolor: "#fff",
                boxShadow: 1,
                "&:hover": { bgcolor: "#f0f0f0" },
              }}
            >
              <ChevronLeftIcon />
            </IconButton>

            {/* → right arrow */}
            <IconButton
              aria-label="Next card"
              onClick={next}
              sx={{
                position: "absolute",
                right: -40,
                top: "50%",
                transform: "translateY(-50%)",
                bgcolor: "#fff",
                boxShadow: 1,
                "&:hover": { bgcolor: "#f0f0f0" },
              }}
            >
              <ChevronRightIcon />
            </IconButton>
          </>
        )}
        {view === "front" && <FrontPopUp card={cards[idx]} />}{" "}
        {view === "back" && (
          <BackPopUp card={cards[idx]} onSettingsClick={handleOpenSettings} />
        )}
        {view === "settings" && (
          <SettingsPopUp card={cards[idx]} onBack={handleBackFromSettings} />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CardPopup;
